import { render, staticRenderFns } from "./yuceRevise.vue?vue&type=template&id=6574b74c&scoped=true"
import script from "./yuceRevise.vue?vue&type=script&lang=js"
export * from "./yuceRevise.vue?vue&type=script&lang=js"
import style0 from "./yuceRevise.vue?vue&type=style&index=0&id=6574b74c&prod&scoped=true&lang=scss"
import style1 from "./yuceRevise.vue?vue&type=style&index=1&id=6574b74c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6574b74c",
  null
  
)

export default component.exports